module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAAZ0lEQVR42u3WsQ2AMAxE0RTMaAL7pWDGIB0FC7j5igz3B7gnpYjcmnMukTYNBTl/SZoYoaE3ilBofoK4aWI3kSO6iRxxmMgRJ0zAAPxExee751d918Xno/g8exXxpyN9/OLnu3M/6AET8HWFXYky9QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/right-carousel-arrow.png
// module id = zTh7
// module chunks = 0